import React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { getTokens } from './theme/index.js';
export const ThemeProvider = ({ children, theme }) => (React.createElement(StyledComponentsThemeProvider, { theme: { ...theme, ...getTokens(theme?.name) } }, children));
//# sourceMappingURL=index.js.map